export const contactsData = {
    email: 'herreracontrerasva@gmail.com',
    phone: '+541122999763',
    address: 'La Plata, Argentina',

    sheetAPI: ''
}